<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  reportTypes: { type: Array, default: () => [] },
  readonly: { type: Boolean, default: false },
  exceedsLimit: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();

const selectedPercent = computed(
  () =>
    props.reportTypes.find(
      report => String(report.id) === String(props.modelValue)
    )?.percent || 0
);

const reportLabel = reportType => {
  if (reportType === 'simples')
    return t('REAL_ESTATE_COMMISSION_INSTALLMENT.OPTIONIST_REPORT.SIMPLES');
  if (reportType === 'com_chave')
    return t('REAL_ESTATE_COMMISSION_INSTALLMENT.OPTIONIST_REPORT.COM_CHAVE');
  if (reportType === 'exclusividade')
    return t(
      'REAL_ESTATE_COMMISSION_INSTALLMENT.OPTIONIST_REPORT.EXCLUSIVIDADE'
    );
  if (reportType === 'lançamento')
    return t('REAL_ESTATE_COMMISSION_INSTALLMENT.OPTIONIST_REPORT.LANCAMENTO');

  return t('REAL_ESTATE_COMMISSION_INSTALLMENT.OPTIONIST_REPORT.UNKNOWN');
};
</script>

<template>
  <LaisCard
    :title="t('REAL_ESTATE_COMMISSION_INSTALLMENT.OPTIONIST_REPORT.TITLE')"
  >
    <div class="flex flex-wrap items-center gap-2">
      <span class="text-sm text-lais-text-muted">
        {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.OPTIONIST_REPORT.PERCENT') }}
      </span>
      <span
        class="rounded-full bg-emerald-100 px-2.5 py-1 text-sm font-semibold text-emerald-800"
      >
        {{
          t('REAL_ESTATE_COMMISSION_INSTALLMENT.COMMON.PERCENTAGE', {
            value: selectedPercent,
          })
        }}
      </span>
    </div>

    <div class="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <label
        v-for="reportType in reportTypes"
        :key="reportType.id"
        class="flex min-h-11 cursor-pointer items-center gap-2 rounded-lais border border-lais-border-soft bg-white px-3 py-2 text-sm has-[:checked]:border-lais-primary has-[:checked]:bg-lais-primary/5"
      >
        <input
          type="radio"
          name="optionist-report-type"
          :value="reportType.id"
          :checked="String(modelValue) === String(reportType.id)"
          :disabled="readonly"
          class="accent-lais-primary"
          @change="emit('update:modelValue', reportType.id)"
        />
        <span>{{ reportLabel(reportType.id) }}</span>
      </label>
    </div>

    <p
      v-if="exceedsLimit"
      class="mt-3 text-sm font-medium text-red-700"
      role="alert"
    >
      {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.ERRORS.OPTIONIST_REPORT') }}
    </p>
  </LaisCard>
</template>
